// extracted by mini-css-extract-plugin
module.exports = {"tab":"Tab_tab__3-hDu","tabH4":"Tab_tabH4__1-k4_","tabBody":"Tab_tabBody__3lxyn","tabHolder":"Tab_tabHolder__2xOgd"};